(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeePhoneDetailController', EmployeePhoneDetailController);

    /* Added UIFormAccess
    EmployeePhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'EmployeePhone', 'Employee', 'AdvertisingSource'];

    function EmployeePhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, EmployeePhone, Employee, AdvertisingSource) {
    */
    EmployeePhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'EmployeePhone', 'Employee', 'AdvertisingSource', 'PhoneType', 'UIFormAccess'];

    function EmployeePhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, EmployeePhone, Employee, AdvertisingSource, PhoneType, UIFormAccess) {
        var vm = this;

        vm.employeePhone = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:employeePhoneUpdate', function(event, result) {
            vm.employeePhone = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
